export type OrganizationUnitEventType = number;

export const organizationUnitEventTypeValues: OrganizationUnitEventType[] = [1, 2, 3, 4];

export const organizationUnitEventTypeLabels: Record<OrganizationUnitEventType, string> = {
  1: 'Inauguracion',
  2: 'Cierre por remodelacion',
  3: 'Cierre definitivo',
  4: 'Reapertura',
};

export const organizationUnitEventTypeIcons: Record<OrganizationUnitEventType, string> = {
  1: 'celebration',
  2: 'construction',
  3: 'lock',
  4: 'door_open',
};

export const organizationUnitEventTypeOptions = organizationUnitEventTypeValues.map(value => ({
  value,
  label: organizationUnitEventTypeLabels[value],
}));
